import mHelper from '../../config/Helper';
class LoginControllers {

    LOGIN_EXECUTE = (email,password,code,captca ,callback) => {
        fetch(mHelper.URL_API()+"/users/login", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
                // "Authorization" : "Bearer "+isLogin.token
            },
            body:JSON.stringify({
                email : email,
                password:password,
                code: code,
                captca:captca
            })
        })
        .then((response) =>response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    LOGIN_GET_CAPTCA_EXECUTE = (code,callback) =>{
        fetch(mHelper.URL_API()+"/users/getcaptca", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
                // "Authorization" : "Bearer "+isLogin.token
            },
            body:JSON.stringify({
                code: code,
            })
        })
        .then((response) =>response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    FORGOT_PASS_REQ = (email,callback) =>{
        fetch(mHelper.URL_API()+"/profile/forgot", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
                // "Authorization" : "Bearer "+isLogin.token
            },
            body:JSON.stringify({
                email: email
            })
        })
        .then((response) =>response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    FORGOT_PASS_TOKEN_CHECK = (token,callback) =>{
        fetch(mHelper.URL_API()+"/check-forgot-token", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
                // "Authorization" : "Bearer "+isLogin.token
            },
            body:JSON.stringify({
                token: token
            })
        })
        .then((response) =>response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    FORGOT_PASS_EXE = (token,new_pass,confirm_pass,callback) =>{
        fetch(mHelper.URL_API()+"/change-forgot-password", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
                // "Authorization" : "Bearer "+isLogin.token
            },
            body:JSON.stringify({
                token: token,
                new_pass : new_pass,
                confirm_pass : confirm_pass
            })
        })
        .then((response) =>response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

}

const mLoginController = new LoginControllers();
export default mLoginController;